export default {
  common: {
    more: "查看更多",
    pleaseInput: "请输入",
    cancel: "取消",
    login: "登录",
    logout: "退出",
    logoutFull: "退出登录",
    registerNow: "立即注册",
    loginOrRegister: "登录/注册",
    home: "首页",
    mine: "我的",
    backToTop: "回到顶部",
    scanWechat: "扫码关注官方微信",
  },
  status: {
    living: "正在直播",
    live: "直播",
    video: "视频",
    book: "预约",
    replay: "回看",
    ended: "结束",
    collection: "合辑",
  },
  tab: {
    live: "直播",
    living: "正在直播",
    latest: "最新",
    latestActivities: "最新活动",
    hot: "热门",
    hotActivities: "热门活动",
  },
  watching: "{n}人在看",
  views: "{n}人观看",
  catalogUpdated: "已更新{n}个活动",
  search: {
    hot: "热搜词",
    activity: "活动",
    totalPrefix: "共 ",
    totalSuffix: " 个",
  },
  countdown: {
    day: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    empty: "请设置倒计时时间",
  },
  brand: {
    fans: "粉丝",
    followAttr: "关注",
    heat: "热度",
    visit: "访问",
    followed: "已关注",
    follow: "关注",
  },
  alert: {
    pageNotFound: "未找到此门户页，请检查地址",
    noData: "未检测到门户页数据，请检查控制台是否保存！",
  },
  alt: {
    brandLogo: "品牌logo",
    banner: "轮播",
    imageNav: "图文导航",
    sudokuNav: "九宫格",
  },
};
